<div [ngClass]="classList">
  <ng-container *ngIf="showNotification">
    <div class="eos-system-notification" #divEl></div>
  </ng-container>
</div>
